"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
const CHANGE_EVENT = "vh-session-flag-change";

/** Subscribes to same-tab session flag changes. */
function subscribe(onStoreChange: () => void) {
  window.addEventListener(CHANGE_EVENT, onStoreChange);
  return () => window.removeEventListener(CHANGE_EVENT, onStoreChange);
}

/** Boolean flag stored in sessionStorage, shared by every subscriber in the tab. */
export function useSessionFlag(key) {
  const $ = _c(7);
  let t0;
  if ($[0] !== key) {
    t0 = () => sessionStorage.getItem(key) !== null;
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isSet = useSyncExternalStore(subscribe, t0, _temp);
  let t1;
  if ($[2] !== key) {
    t1 = () => {
      sessionStorage.setItem(key, "1");
      window.dispatchEvent(new Event(CHANGE_EVENT));
    };
    $[2] = key;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const set = t1;
  let t2;
  if ($[4] !== isSet || $[5] !== set) {
    t2 = [isSet, set];
    $[4] = isSet;
    $[5] = set;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2 as const;
}
function _temp() {
  return false;
}